// Dependencies imports
import React, { useState, useEffect, useRef } from "react";
import { API } from "aws-amplify";
import { Card, CardMedia, Typography, CardContent } from "@material-ui/core";
import { Link, useNavigate } from "react-router-dom";
import { Constants } from "../../config/constants";
import config from "../../config/aws-exports";
import Skeleton from "@material-ui/lab/Skeleton";

import { awsSignIn, authData } from "../../redux/auth/authSlice";
import { useSelector, useDispatch } from "react-redux";

// Local imports
import UserHeader from "../Header/UserHeader/UserHeader";

// Styles imports
import Cont from "./Content.module.scss";

// Start of Content Component
const Content = () => {
  const [progDetails, setProgDetails] = useState({});
  const [isLoading, setLoading] = useState(true);

  let userDetails = useSelector(authData);
  let navigate = useNavigate();
  const dispatch = useDispatch();
  console.log("user", userDetails);

  useEffect(() => {
    getProgDetails();
    breadcrumb();
  }, []);

  async function getProgDetails() {
    const bodyParam = {
      body: {
        bpid: userDetails.curprgcou.bpid,
        oid: config.aws_org_id,
        pid: userDetails.curprgcou.pid,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    if (
      userDetails.role == "Instructors" ||
      userDetails.role == "Coordinators"
    ) {
      bodyParam.body.eid = userDetails.eid;
    }
    try {
      console.log(bodyParam.body);
      const PDetails = await API.post(
        config.aws_cloud_logic_custom_name,
        `/getProgramsDetails`,
        bodyParam
      );
      console.log("PDetails", PDetails.pcurriculum);

      PDetails.pcurriculum = PDetails.pcurriculum.reduce((acc, current) => {
        const x = acc.find((item) => item.tid === current.tid);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
      setProgDetails(PDetails);
      setLoading(false);
      console.log(PDetails);
    } catch (error) {
      // alert(JSON.stringify(error));
      console.error(error);
    }
  }

  const enableDisablePost = async (item, idx) => {
    console.log(item);
    setLoading(true);
    const bodyParam = {
      body: {
        tid: item.tid,
        oid: config.aws_org_id,
        btid: item.btid,
        bpid: userDetails.curprgcou.bpid,
        disable: !item.tenabled,
        pid: userDetails.curprgcou.pid,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    console.log(JSON.stringify(bodyParam.body, null, 2));
    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        "/enableCourse",
        bodyParam
      );
      progDetails.pcurriculum[idx].tenabled = !item.tenabled;
      setProgDetails(progDetails);
      console.log(JSON.stringify(progDetails, null, 2));
      setLoading(false);
      // return response;
    } catch (error) {
      console.log("enableNuggetserre", error);
    }
  };

  function breadcrumb() {
    let sdata = { ...userDetails };
    let temp = [...sdata.breadcrumb];

    temp[2] = {
      name: "Content",
      path: "/Content",
    };

    sdata.breadcrumb = temp;

    dispatch(awsSignIn(sdata));
  }

  function titleclick(data) {
    console.log(JSON.stringify(data, null, 2));
    let sdata = { ...userDetails };
    // for(let i = 0; i < pdata.length; i++){
    //   if(data.bpid == pdata[i].bpid){
    //     sdata.curprgcou = pdata[i];
    //   }
    // }
    sdata.seminfo = { tlabel: data.tlabel, semester: data.semester };
    sdata.curprg = { ...data };

    sdata.curprg.pid = userDetails.curprgcou.pid;
    sdata.curprg.bpid = userDetails.curprgcou.bpid;
    sdata.btid = data.btid;

    let temp = [...sdata.breadcrumb];

    temp[3] = {
      name: "Course View",
      path: "/applicationdetails",
    };

    sdata.breadcrumb = temp;

    dispatch(awsSignIn(sdata));

    navigate("/courseView");
  }

  function onClickOfPage(name, path) {
    let sdata = { ...userDetails };
    let temp = [...sdata.breadcrumb];

    temp[3] = {
      name: name,
      path: path,
    };

    sdata.breadcrumb = temp;

    dispatch(awsSignIn(sdata));
  }
  return (
    <div className={Cont.maincontainer}>
      <UserHeader Bindex={2} />
      <div className={Cont.topbar}>
        <h3 className={Cont.header}>Content</h3>
        <button
          className={
            window.navigator.onLine === true
              ? Cont.btn_color
              : Cont.btn_colordis
          }
          disabled={!window.navigator.onLine}
          onClick={() => {
            navigate("/courseCreation");
            onClickOfPage("Course Creation", "/courseCreation");
          }}
        >
          Create course
        </button>
      </div>

      <div className={Cont.cardholder}>
        {isLoading && (
          <>
            {["h1", "h1", "h1"].map((item) => (
              <>
                <Card style={{ height: "300px" }}>
                  <CardMedia>
                    <div className={Cont.image}>
                      <Skeleton variant="rect" height={130} />
                    </div>
                  </CardMedia>
                  <CardContent style={{ padding: "10px" }}>
                    <h1 className={Cont.coursename}>
                      <Typography component="div" variant="h1">
                        <Skeleton />
                      </Typography>
                      <Typography component="div" variant="h3">
                        <Skeleton />
                      </Typography>
                    </h1>
                  </CardContent>
                </Card>
              </>
            ))}
          </>
        )}
        {progDetails.pcurriculum !== undefined && !isLoading ? (
          progDetails.pcurriculum.map((item, idx) => (
            <div className={Cont.cards}>
              <Card style={{ height: "300px" }}>
                <CardMedia>
                  <img
                    className={Cont.image}
                    src={`https://${
                      config.DOMAIN
                    }/${config.aws_org_id.toLowerCase()}-resources/images/topic-images/${
                      item.tid
                    }.png`}
                    alt="program"
                  />
                </CardMedia>
                <CardContent style={{ padding: "10px" }}>
                  <h2 className={Cont.coursename}>{item.tlabel}</h2>
                  <h3
                    className={Cont.coursecontent}
                    onClick={() => titleclick(item)}
                  >
                    {item.ttitle.substring(0, 40)}
                    {item.ttitle.length > 40 ? "..." : null}
                  </h3>
                  {item.tenabled === true ? (
                    <button
                      className={
                        window.navigator.onLine === true
                          ? Cont.disablebutton
                          : Cont.btn_colordisa
                      }
                      disabled={!window.navigator.onLine}
                      onClick={() => {
                        enableDisablePost(item, idx);
                      }}
                    >
                      Click to Disable
                    </button>
                  ) : (
                    <button
                      className={
                        window.navigator.onLine === true
                          ? Cont.disablebutton
                          : Cont.btn_colordisa
                      }
                      disabled={!window.navigator.onLine}
                      onClick={() => {
                        enableDisablePost(item, idx);
                      }}
                    >
                      Click to Enable
                    </button>
                  )}
                </CardContent>
              </Card>
            </div>
          ))
        ) : (
          <p></p>
        )}
      </div>
    </div>
  );
};

export default Content;
